module.exports = __webpack_public_path__ + "static/media/028.f36c926c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/thumbs/028.jpg
// module id = 375
// module chunks = 0